// components/SearchOverlay.tsx
import { useSidebar } from "../context/SidebarContext";
import { SearchIcon, CloseIcon } from "../icons";

const SearchOverlay = () => {
    const { isSearchOpen, closeSearch } = useSidebar();

    if (!isSearchOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] bg-black bg-opacity-50 flex items-start justify-center pt-20 md:hidden">
            <div className="bg-white w-11/12 max-w-md rounded-lg shadow-lg p-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold">Search</h3>
                    <button
                        onClick={closeSearch}
                        className="p-1 hover:bg-gray-100 rounded-full"
                    >
                        <CloseIcon className="w-6 h-6" />
                    </button>
                </div>

                <div className="flex w-full h-12 overflow-hidden mb-4">
                    <input
                        type="text"
                        placeholder="Search products, services..."
                        className="w-full py-2 px-4 text-gray-700 placeholder-gray-500 border rounded-l-lg brand-border focus:outline-none focus:ring-0"
                        autoFocus
                    />
                    <button
                        type="submit"
                        className="flex items-center justify-center px-4 rounded-r-lg brand-bg brand-bg-hover text-white"
                    >
                        <SearchIcon className="w-5 h-5 fill-white" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchOverlay;